import { signalConstants } from '../constants';
import { signalService } from '../services';
import { generalErrorHandler } from './utils';

function listSignals() {
  return dispatch => {
    dispatch(request());

    return signalService.list().then(
      signals => {
        dispatch(success(signals));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: signalConstants.GET_ALL_REQUEST };
  }
  function success(signals) {
    return { type: signalConstants.GET_ALL_SUCCESS, signals };
  }
  function failure(error) {
    return { type: signalConstants.GET_ALL_FAILURE, error };
  }
}

export default {
  listSignals,
};
